import { PaytrieAPI } from '@paytrie/client'

export type BankAccount = PaytrieAPI.BankAccount

const requestFailed = (status: number): Error =>
  new Error(`Request failed with status ${status}`)

export async function listBankAccounts(userId: string): Promise<BankAccount[]> {
  const response = await PaytrieAPI.listUserBankAccounts(userId)
  if (response.status === 200 && response.data.success) {
    return response.data.data.items
  }
  throw requestFailed(response.status)
}
